// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1278":"67e0ece4","6844":"9c14234a"}[chunkId] + ".chunk.css";
};